module.exports = __webpack_public_path__ + "img/123.a9a540d1.png";